import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  usageFirstRow: {
    flexDirection: 'row',
  },
  usageLabelTextStyle: theme => ({
    fontSize: 18.7,
    lineHeight: 25,
    color: theme.colors.headerTitleColor,
    paddingRight: 3,
  }),
  usedAmountTextStyle: theme => ({
    fontSize: 18.7,
    lineHeight: 25,
    color: theme.colors.headerTitleColor,
    ...Fonts.type.bold,
    marginTop: Platform.OS === 'ios' ? -2 : 0,
  }),
  totalAmountTextStyle: theme => ({
    fontSize: 14.6,
    lineHeight: 18.7,
    color: theme.colors.headerTitleColor,
    paddingVertical: 8,
  }),
  addButtonStyle: {
    marginTop: 10,
  },
  addButtonTextStyle: theme => ({
    color: theme.colors.textColor,
    fontSize: 18.7,
    lineHeight: 25,
  }),
});
